var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6666 25.3333C30.6666 26.0406 30.3856 26.7189 29.8855 27.219C29.3854 27.719 28.7072 28 27.9999 28H3.99992C3.29267 28 2.6144 27.719 2.1143 27.219C1.6142 26.7189 1.33325 26.0406 1.33325 25.3333V10.6667C1.33325 9.95942 1.6142 9.28115 2.1143 8.78105C2.6144 8.28095 3.29267 8 3.99992 8H9.33325L11.9999 4H19.9999L22.6666 8H27.9999C28.7072 8 29.3854 8.28095 29.8855 8.78105C30.3856 9.28115 30.6666 9.95942 30.6666 10.6667V25.3333Z",
    stroke: "url(#paint0_linear_107_179)",
    strokeWidth: 2.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 22.6667C18.9456 22.6667 21.3334 20.2789 21.3334 17.3333C21.3334 14.3878 18.9456 12 16.0001 12C13.0546 12 10.6667 14.3878 10.6667 17.3333C10.6667 20.2789 13.0546 22.6667 16.0001 22.6667Z",
    stroke: "url(#paint1_linear_107_179)",
    strokeWidth: 2.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_179",
    x1: 15.9999,
    y1: 4,
    x2: 15.9999,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#134A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13675f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_179",
    x1: 16.0001,
    y1: 12,
    x2: 16.0001,
    y2: 22.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#134A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13675f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.84504dde0d14c8e7e26940284b3712e4.svg";
export { ForwardRef as ReactComponent };